import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import DevBackendBadge from './components/DevBackendBadge';
import reportWebVitals from './reportWebVitals';
import './utils/pwaInstall';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <DevBackendBadge />
  </React.StrictMode>
);

// Register the service worker (also used for push) so the app is installable.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL || ''}/sw.js`, { scope: `${process.env.PUBLIC_URL || ''}/` })
      .catch((err) => console.warn('Service worker registration failed:', err.message));
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
